<template>
  <component
    v-if="use"
    :is="computedDynamicIcon"
  />
</template>

<script>
import { STATUS_TRACKER_ICONS_LIST } from '../status-tracker.utils'

export default {
  name: 'JadeStatusTrackerIcon',

  props: {
    use: {
      type: String,
      validation: icon => STATUS_TRACKER_ICONS_LIST.includes(icon)
    }
  },

  computed: {
    computedDynamicIcon () {
      return this.use
        ? () =>
            import(
              /* webpackChunkName: "jade-design-tokens/status-tracker/[request]" */ '@stone-payments/jade-design-tokens/status-tracker/' +
                this.use +
                '.svg?inline'
            )
        : ''
    }
  }
}
</script>
